import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { JwtHelperService } from '@auth0/angular-jwt';

import { CKPassLoginModel } from '@core/models/interfaces/login.interface';
import { LocalStorageService, MstMessageService, keyTriggerSession } from '../common';
import { AuthService } from './auth.service';
import { LOCAL_STORAGE_KEY } from '@core/configs/local-storage-key.config';
import { SaucerLogService } from '@core/services/apis/saucer-log.service';

@Injectable()
export class LoginService {
    jwtHelper = new JwtHelperService();

    constructor(
        public translate: TranslateService,
        private authService: AuthService,
        private mstMessageService: MstMessageService,
        private localStorageService: LocalStorageService,
        private saucerLogService: SaucerLogService,
    ) { }

    async loginByCKPass(loginData: CKPassLoginModel) {
        try {
            const res = await this.authService.loginByCKPass(loginData);
            if (res && res.result) {
                const userSession = {
                    accessToken: res.result.accessToken,
                    refreshToken: res.result.refreshToken,
                };
                this.localStorageService.setUserSession(userSession);
                this.localStorageService.trigger(keyTriggerSession.setToken);
                localStorage.setItem(LOCAL_STORAGE_KEY.userId, res.result.userId);
                await this.mstMessageService.getMstMessageList();

                const fullName = res.result.lastName + res.result.firstName;
                localStorage.setItem(LOCAL_STORAGE_KEY.fullName, fullName);
                localStorage.setItem(LOCAL_STORAGE_KEY.handleFirstMenu, JSON.stringify(false));

                // Write login log
                this.saucerLogService.logLogin();
                this.authService.setIsLoggedIn(true);
                return true;
            }
        } catch (e) {
            throw e;
        }
    }
}
